import ModalAutosuggest from '../ModalAutosuggest/index.js'

export const AUTOSUGGEST_COMPONENTS_BY_DESIGN = {
  modalPopover: ModalAutosuggest
}
